import { Directive, ElementRef, OnInit } from '@angular/core';
import lottie from 'lottie-web';

@Directive({
    selector: '[directive-lottie]',
})
export class LottieDirective implements OnInit {
    private _animationName: string;

    constructor(
        private _elementRef: ElementRef,
    ) { }

    ngOnInit() {
        this._animationName = this._elementRef.nativeElement.getAttribute('directive-lottie');

        if (!this._animationName || !lottie) return;

        lottie.loadAnimation({
            container: this._elementRef.nativeElement,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `/assets/animations/${this._animationName}.json`
        });
    }
}
